import { render, staticRenderFns } from "./CardRoomName.vue?vue&type=template&id=7edd9c5c&scoped=true"
import script from "./CardRoomName.vue?vue&type=script&lang=js"
export * from "./CardRoomName.vue?vue&type=script&lang=js"
import style0 from "./CardRoomName.vue?vue&type=style&index=0&id=7edd9c5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7edd9c5c",
  null
  
)

export default component.exports